(function () {
    'use strict';

    // Usage: <ib-ancillaries-upgrading model="" basket-functions=""></ib-ancillaries-upgrading>
    //
    // Creates:
    //
    angular
        .module('ib-ancillaries-upgrading-module')
        .component('ibAncillariesUpgrading', {
            controller: 'AncillariesUpgradingController',
            controllerAs: 'upgradingCtrl',
            bindings: {
                model: '=',
                basketFunctions: '='
            },
            templateUrl: ['$rootScope', function ($rootScope) {
                return $rootScope.routes.templates + 'ib-ancillaries-upgrading-view.html';
            }]
        });
})();